import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Patient } from '../models/patient.model';

@Injectable({
  providedIn: 'root'
})
export class SelectedPatientService {
  private selectedPatientSubject = new BehaviorSubject<Patient | null>(null);
  selectedPatient$: Observable<Patient | null> = this.selectedPatientSubject.asObservable();

  constructor() {}

  selectPatient(patient: Patient) {
    console.log("Here is the new patient in the service: ", patient);
    this.selectedPatientSubject.next(patient);
  }
}
